// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var icon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.px(45)),
      BsCssJs$PrezzeeRibbon.flexGrow(0),
      BsCssJs$PrezzeeRibbon.flexShrink(0),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(45)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(8)),
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(24)),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Business.prezzeePurple),
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Business.stone),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.em(1)),
            BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.em(1)),
            BsCssJs$PrezzeeRibbon.display("inlineBlock"),
            BsCssJs$PrezzeeRibbon.width("auto"),
            BsCssJs$PrezzeeRibbon.height("auto")
          ])
    ]);

var Styles = {
  icon: icon
};

function TheGiftExperience__ListItemIcon(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: icon
            });
}

var make = TheGiftExperience__ListItemIcon;

export {
  Styles ,
  make ,
}
/* icon Not a pure module */
